enum AcfIconPosition {
  TopCenter = "Top Center",
  TopLeft = "Top Left",
  Left = "Left",
}

export default AcfIconPosition;
